import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { COMPLETE } from '../../helpers/vault_access_helper';
import { fetchTranslation } from '../../../../helpers/i18n';

export default function CaAlreadySigned({ onNext }) {
  return (
    <div className="text-center d-flex flex-column gap-4 my-2">
      <FontAwesomeIcon className="text-branding" icon={faCheckCircle} size="2x"/>
      <h5 className="mb-0">
        <strong>{fetchTranslation('ca_already_signed')}</strong>
      </h5>
      <p className="mb-0">{fetchTranslation('ca_already_signed_body')}</p>
      <Button
        className="w-100"
        data-testid="ca-already-signed-continue"
        variant="primary"
        onClick={() => onNext({ overrideStep: COMPLETE })}
      >
        {fetchTranslation('continue')}
      </Button>
    </div>
  );
}

CaAlreadySigned.propTypes = {
  onNext: PropTypes.func.isRequired
};
